import { createTheme } from "@mui/material/styles";

const _musicList = [
  {
    name: "鄭中基20首必聽廣東歌",
    url: "https://youtu.be/A0loLRuZ1eY",
    uuid: "A0loLRuZ1eY",
  },
  {
    name: "50首國語懷舊經典金曲",
    url: "https://youtu.be/mnnzZKbsrqM",
    uuid: "mnnzZKbsrqM",
  },
  {
    name: "80-90年代流行歌曲",
    url: "https://youtu.be/Vv3euZJkjwM",
    uuid: "Vv3euZJkjwM",
  },
  {
    name: "香港电影中的50首经典歌曲",
    url: "https://youtu.be/DRaYnlu8LWc",
    uuid: "DRaYnlu8LWc",
  },
  {
    name: "40首中文流行音樂",
    url: "https://youtu.be/VXDeI7XKeEQ",
    uuid: "VXDeI7XKeEQ",
  },
  {
    name: "广东男女对唱歌曲",
    url: "https://youtu.be/S1sDgOiRN0c",
    uuid: "S1sDgOiRN0c",
  },
  {
    name: "Beyond 不能錯過的30首精選經典金曲",
    url: "https://youtu.be/oJlEgKChj40",
    uuid: "oJlEgKChj40",
  },
  {
    name: "90年代當紅藝人精選",
    url: "https://youtu.be/4eWYkoWYzjo",
    uuid: "4eWYkoWYzjo",
  },
  {
    name: "80 90年代经典老歌",
    url: "https://youtu.be/qsv3nVuVrQg",
    uuid: "qsv3nVuVrQg",
  },
  // {
  //   name: "2020超好听粤语新歌",
  //   url: "https://youtu.be/-EVJfioKoKQ",
  //   uuid: "-EVJfioKoKQ",
  // },
  {
    name: "林子祥经典",
    url: "https://youtu.be/IPhh0-PdOPk",
    uuid: "IPhh0-PdOPk",
  },
  {
    name: "梅艳芳 Anita Mui",
    url: "https://youtu.be/ZVr85Gjwi0k",
    uuid: "ZVr85Gjwi0k",
  },
  {
    name: "陳慧嫻 Priscilla Chan",
    url: "https://youtu.be/QHttVagyFic",
    uuid: "QHttVagyFic",
  },
  {
    name: "李克勤 Hacken Lee",
    url: "https://youtu.be/7LZoIkfeqKs",
    uuid: "7LZoIkfeqKs",
  },
  {
    name: "譚詠麟 Alan Tam",
    url: "https://youtu.be/TStIHcs095w",
    uuid: "TStIHcs095w",
  },
  {
    name: "2001-2010華語流行歌曲",
    url: "https://youtu.be/yhOACkeuq8M",
    uuid: "yhOACkeuq8M",
  },
  {
    name: "經典好聽的歌曲合集",
    url: "https://youtu.be/MmfRVNOX7zk",
    uuid: "MmfRVNOX7zk",
  },
  {
    name: "老歌精選 / 一人一首成名曲",
    url: "https://youtu.be/7DISYsQ0ezY",
    uuid: "7DISYsQ0ezY",
  },
  {
    name: "許冠傑 Sam Hui",
    url: "https://youtu.be/9hQeNCG43ss",
    uuid: "9hQeNCG43ss",
  },
];

const _healthInfoList = [
  {
    name: "【精華版 | 認識流感疫苗】你是流感高危人士嗎？什麼情況死亡風險會增至6倍？",
    url: "https://youtu.be/pyh77GUXwfA?si=zxEGTJ3DsgbQtUiV",
    uuid: "pyh77GUXwfA?si=zxEGTJ3DsgbQtUiV",
  },
  {
    name: "【足本版 | 認識流感疫苗】你是流感高危人士嗎？什麼情況死亡風險會增至6倍？",
    url: "https://youtu.be/DHRuzemJFn8?si=xiPWdx89BgyJAfj0",
    uuid: "DHRuzemJFn8",
  },
  {
    name: "【哪些人應做胃鏡檢查？ | 浸醫與您】 ─ 梁景燊醫生 （香港浸信會醫院腸胃及肝臟內科中心主任）",
    url: "https://youtu.be/01CvIx6-bms?si=svwhDcp6GCcYiVbe",
    uuid: "01CvIx6-bms",
  },
  {
    name: "【胃酸倒流 | 浸醫與您】 ─ 梁景燊醫生 （香港浸信會醫院腸胃及肝臟內科中心主任）",
    url: "https://youtu.be/UZpB5k12ohU?si=hrV8ITLG0yExft_3",
    uuid: "UZpB5k12ohU",
  },
  {
    name: "【腸易激綜合症 | 浸醫與您】 ─ 梁景燊醫生 （香港浸信會醫院腸胃及肝臟內科中心主任）",
    url: "https://youtu.be/h0lQrmFbMjQ?si=F7OKQ95VbKLkjtxu",
    uuid: "h0lQrmFbMjQ",
  },
  {
    name: "【哪些人應做大腸鏡檢查？ | 浸醫與您】 ─ 黎啟昌醫生 （香港浸信會醫院微創外科中心主任及顧問醫生）",
    url: "https://youtu.be/mbS28L4L4RE?si=typkFJ4iDfxe4hSx",
    uuid: "mbS28L4L4RE",
  },
  {
    name: "【腸癌病徵 | 浸醫與您】 ─ 黎啟昌醫生 （香港浸信會醫院微創外科中心主任及顧問醫生）",
    url: "https://youtu.be/Yv3ePybpfbU?si=Fkc82mkYE7L9T-KK",
    uuid: "Yv3ePybpfbU",
  },
  {
    name: "【腸瘜肉微創治療 | 浸醫與您】 ─ 黎啟昌醫生 （香港浸信會醫院微創外科中心主任及顧問醫生）",
    url: "https://youtu.be/E7VKSZ6lRWo?si=VY8ND7KwEb_cT3Sj",
    uuid: "E7VKSZ6lRWo",
  },
  {
    name: "【認識肺癌 | 浸醫與您】 ─ 傅惠霖醫生 （香港浸信會醫院腫瘤中心主任）",
    url: "https://youtu.be/c_ef6a19374?si=us4mK_nPf_F6mARt",
    uuid: "c_ef6a19374",
  },
  {
    name: "【認識神經痛 | 浸醫與您】 ─ 鄭達燊醫生 （香港浸信會醫院腦神經科專科醫生）",
    url: "https://youtu.be/lfVyq-GX7EY?si=AqOa6-fVO8SezGKi",
    uuid: "lfVyq-GX7EY",
  },
  {
    name: "【認識痛症 | 浸醫與您】 ─ 何湛安醫生 （香港浸信會醫院骨科顧問醫生）",
    url: "https://youtu.be/tG1aML-Ihrs?si=Y0Um9nz5OInPXJTz",
    uuid: "tG1aML-Ihrs",
  },
];

function UserConfig() {
  // 如果有現成的就丟回去 沒有的話 執行第一次建構
  if (typeof UserConfig.cache === "object") {
    return UserConfig.cache;
  }
  this.hkoLang = "tc";
  UserConfig.cache = this;
}

function AppSingleton() {
  if (typeof AppSingleton.cache === "object") {
    return AppSingleton.cache;
  }
  // TODO: binding the leave page and navigation
  this.topBarHeight = 64; // MARK: Now only for recycling game
  this.leavePage = () => {
    const onAnimationCompleted = () => {
      this.navigate(-1);
    };
    return onAnimationCompleted;
  };
  this.theme = createTheme({
    transitions: {
      easing: {
        easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
        easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
        easeIn: "cubic-bezier(0.4, 0, 1, 1)",
        sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
      },
    },
  });
  this.news_articles = [];
  this.news_order = 0;
  this.gpt_pending_pool = [];
  this.currentAudioSource = null;
  AppSingleton.cache = this;
}

export { AppSingleton, UserConfig, _musicList, _healthInfoList };
